import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

type Props = {
    pageIds: Array<number | string>,
    pageSelectedCount: number,
    allSelected: boolean,
    onSelectPage: () => void,
};

export const SelectPageView: React.FC<Props> = ({
    pageIds,
    pageSelectedCount,
    allSelected,
    onSelectPage,
}) => {
    const show = !allSelected && pageIds.length > 0 && pageSelectedCount < pageIds.length;
    if (!show) {
        return null;
    }

    return (
        <ToolItem>
            <FlatButton onClick={onSelectPage}>Select Page</FlatButton>
        </ToolItem>
    );
};
